export default () => {
    const form = document.getElementById('PopupForm_PopupForm');
    const content = document.getElementById('SignUpPopup__content');
    const msg = document.getElementById('PopupForm_PopupForm_error');
    const popup = document.querySelector('.cta__signup');

    // Popup only exists on pages with the two-button CTA element
    if (!form || !msg || !popup) {
        return;
    }

    form.addEventListener('submit', function (event) {
        event.preventDefault();

        const formData = new FormData(form);
        const action = form.getAttribute('action');
        const siteKey = document.querySelector('body').getAttribute('recaptcha-site-key');

        grecaptcha.execute(siteKey, {action: 'submit'}).then(function (token) {
            formData.append('g-recaptcha-response', token);
            fetch(action, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.success) {
                        if (data.fileUrl) {
                            const link = document.createElement('a');
                            link.href = data.fileUrl;
                            link.download = '';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }

                        // Clear the form fields
                        form.reset();
                        form.innerText = '';
                        if (content) {
                            content.innerText = '';
                        }
                        msg.innerText = data.fileUrl ?
                            'Your details have been submitted. Please check the downloaded file. Thank you!' :
                            'Your details have been submitted. Thank you!';

                        setTimeout(() => {
                            popup.classList.remove('active');
                        }, 3000);
                    } else {
                        msg.innerText = data.message || 'An error occurred';
                    }
                    // Scroll to the message
                    msg.scrollIntoView({behavior: 'smooth'});
                })
                .catch(error => {
                    console.error('Error occurred:', error);
                    msg.innerText = 'An error occurred while submitting the form';
                    // Scroll to the error message
                    msg.scrollIntoView({behavior: 'smooth'});
                });
        });
    });
};
